/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      21 February 2024
 */

import Hero from '../Components/Hero';

const ContactUs = () => {
  return (
    <Hero
      component={
        <div className='flex flex-col items-center justify-center'>
          <h1 className='text-2xl text-dark-50 font-loos font-semibold text-center'>
            Contact Us
          </h1>
          <p className='font-loos text-xl text-dark-200 text-center mt-4'>
            For any inquiries, please contact us at
            <a href='mailto:hey@artcutcreative.com' className='text-blue-500'>
              {' '}
              hey@artcutcreative.com
            </a>
          </p>
        </div>
      }
    />
  );
};
export default ContactUs;
